import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { Mimetype } from 'app/shared/mimetype';
import { RevertVersionComponent } from '../revert-version/revert-version.component';

@Component({
    selector: 'app-version-history',
    templateUrl: './version-history.component.html',
    styleUrls: ['./version-history.component.css'],
})
export class VersionHistoryComponent implements OnInit {
    errorMessage: string;
    user: any;
    doc_id: any;
    list_version: any;
    items: any;
    translate: any;
    toast: any;
    shared = false;
    tin: any;
    currentVersion: any;

    constructor(@Inject(MAT_DIALOG_DATA) private data: any, private service: IdexService, public dialog: MatDialog) {
        this.user = this.service.user;
    }

    ngOnInit() {
        this.getVersionHistory();
    }

    getVersionHistory() {
        this.service.list_version(this.doc_id)
            .subscribe(data => {
                this.list_version = data;
                this.getCurrentVersion();
            });
    }

    getCurrentVersion() {
      for(let i=0;i<this.list_version.length;i++){
         if(this.list_version[i].version === this.items.version) {
            this.currentVersion = this.list_version[i].version;
            break;
         }
      }
    }

   getIcon(item: any): string {
      return Mimetype.getIcon(item);
   }

    download(item: any) {
        location.href = this.service.url + '/version/' + item.id + '/' +  item.version
           + '/download?token=' + this.service.user.token;
    }

    delete(item: any) {
       if (this.items.startFlow) {
          this.translate.get('alert.warning-task').subscribe( s => {
             this.toast.error(s);
          });
          return;
       } else if (item.startFlow && item.statusDocument === 'Completed') {
          this.translate.get('alert.warning-task-completed').subscribe( s => {
             this.toast.error(s);
          });
          return;
       }
        const delete_dialog = this.dialog.open(RevertVersionComponent, {
            disableClose: true,
            data: this
        });
        delete_dialog.componentInstance.item = item;
        delete_dialog.componentInstance.status = 'delete';
        delete_dialog.componentInstance.translate = this.translate;
        delete_dialog.componentInstance.toast = this.toast;
    }
    revert(item: any) {
       if (this.items.startFlow) {
          this.translate.get('alert.warning-task').subscribe( s => {
             this.toast.error(s);
          });
          return;
       } else if (item.startFlow && item.statusDocument === 'Completed') {
          this.translate.get('alert.warning-task-completed').subscribe( s => {
             this.toast.error(s);
          });
          return;
       }
        const revert_dialog = this.dialog.open(RevertVersionComponent, {
            disableClose: true,
            data: this
        });
        revert_dialog.componentInstance.item = item;
        revert_dialog.componentInstance.currentVersion = this.currentVersion;
        revert_dialog.componentInstance.status = 'revert';
        revert_dialog.componentInstance.translate = this.translate;
        revert_dialog.componentInstance.toast = this.toast;
    }
}
